const carouselItems = [
  {
    tag: '独家爆料',
    title: '某顶流深夜密会神秘女子，实锤照片全网首曝',
    excerpt: '据可靠消息，该顶流近期频繁出入某高档小区，与一名神秘女子关系暧昧，多组跟拍画面曝光。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20atmospheric%20editorial%20photography%2C%20celebrity%20paparazzi%20theme%20with%20abstract%20silhouette%20and%20camera%20flashes%2C%20dramatic%20spotlight%20effect%2C%20coral%20red%20and%20warm%20amber%20accents%2C%20mysterious%20mood%2C%20minimalist%20simple%20background%2C%20magazine%20editorial%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
    alt: '独家爆料：某顶流深夜密会神秘女子',
  },
  {
    tag: '现场直击',
    title: '知名综艺录制现场爆发冲突，导演组紧急叫停',
    excerpt: '某热门综艺最新一期录制现场突发意外，嘉宾与节目组产生激烈争执，导致录制中断长达三小时。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20TV%20studio%20set%20with%20dramatic%20lighting%2C%20empty%20director%20chair%20and%20professional%20camera%20equipment%2C%20warm%20golden%20stage%20lights%2C%20backstage%20atmosphere%2C%20minimalist%20clean%20composition%2C%20modern%20broadcast%20aesthetic&width=800&height=500&seq=carousel-02&orientation=landscape',
    alt: '现场直击：知名综艺录制现场爆发冲突',
  },
  {
    tag: '深度盘点',
    title: '年度最离谱塌房事件盘点，件件震碎三观',
    excerpt: '从顶流失德到网红翻车，2024年娱乐圈塌房事件密集爆发，我们为你梳理了最令人瞠目结舌的十大事件。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20representation%20of%20breaking%20news%20concept%2C%20abstract%20geometric%20shapes%20with%20warm%20red%20and%20gold%20gradients%2C%20newspaper%20fragments%20floating%20in%20composition%2C%20modern%20minimalist%20design%2C%20clean%20soft%20background%2C%20editorial%20vibe&width=800&height=500&seq=carousel-03&orientation=landscape',
    alt: '深度盘点：年度最离谱塌房事件',
  },
  {
    tag: '幕后揭秘',
    title: '娱乐圈资本局中局：谁在幕后操控舆论风向？',
    excerpt: '深挖娱乐圈背后的资本博弈，揭秘那些看不见的手如何操控明星命运、影响舆论走向的惊人内幕。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20chess%20pieces%20and%20money%20symbols%20behind%20a%20theater%20curtain%2C%20warm%20coral%20and%20golden%20color%20palette%2C%20mysterious%20corporate%20intrigue%20mood%2C%20clean%20simple%20background%2C%20modern%20digital%20art&width=800&height=500&seq=carousel-04&orientation=landscape',
    alt: '幕后揭秘：娱乐圈资本局中局',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-8 md:mb-10">
          焦点爆料
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-colors duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.alt}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 2 ? undefined : 'lazy'}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}